import {ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {loaderConfig} from './shared/services/loaderConfig';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authInterceptor} from './shared/services/interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      NgxUiLoaderModule.forRoot(loaderConfig)
    )
  ]
};
